import { render } from "./고객의소리-랜딩.vue?vue&type=template&id=2a41b5fb"
import script from "./고객의소리-랜딩.vue?vue&type=script&lang=js"
export * from "./고객의소리-랜딩.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__